/*
 * Operator-facing copy for a refused login (API-15 / flows/admin-auth). The two refusals the design
 * calls out — bad credentials vs an inactive account — read distinctly; the rate-limit lock and any
 * unexpected failure get their own lines so the operator is never left guessing. Keyed off the
 * response `error.code`, not the HTTP status, so the wording tracks the contract.
 */

const REFUSAL_COPY: Record<string, string> = {
  invalid_credentials: 'The email or password is incorrect.',
  account_inactive: 'This admin account is inactive. Ask a Super Admin to reactivate it.',
  account_locked:
    'Too many failed attempts. This account is temporarily locked; try again shortly.',
};

const GENERIC_REFUSAL = 'Something went wrong signing in. Please try again.';

/** The message to show for a login/reset failure `code` (undefined ⇒ network/unknown). */
export function refusalMessage(code: string | undefined): string {
  return (code !== undefined && REFUSAL_COPY[code]) || GENERIC_REFUSAL;
}
